import { useNavigate } from 'react-router';
import { loginPath } from '@universal/apps/Themed/ThemedApp.utils';

export const useLoginRedirect = () => {
  const navigate = useNavigate();

  const redirectToLoginPage = (returnUrl: string) => {
    navigate(`${loginPath}?returnUrl=${encodeURIComponent(returnUrl)}`);
  };

  return {
    redirectToLoginPage,
  };
};
